<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">Asignar OP a Pallets</h1>
      <b-row>
        <b-col sm="12" md="12" lg="8">
          <b-card no-body>
            <b-row>
              <b-col>
                <h2 class="mt-2 ml-2">Tabla de pallets</h2>
                <p class="ml-2">Seleccione Orden de pedido. Luego pinche los pallets para seleccionar</p>
              </b-col>
              <b-col>
                <b-spinner v-if="loading" small class="m-2 float-right"></b-spinner>
              </b-col>
            </b-row>

            <v-server-table
              class="px-2"
              :url="url"
              :columns="columns"
              :options="options"
              @row-click="selectRow"
              theme="bootstrap4"
              template="default"
              ref="table"
              id="dataTable"
              v-if="url"
            >
              <template #is_complete="row">
                <b-form-checkbox v-model="row.row.is_complete" disabled></b-form-checkbox>
              </template>
              <template #approve="row">
                <b-form-checkbox v-model="row.row.approve" disabled></b-form-checkbox>
              </template>
            </v-server-table>
          </b-card>
        </b-col>
        <b-col sm="12" md="12" lg="4">
          <b-card no-body>
            <b-row>
              <b-col>
                <h2 class="m-2">Pallets seleccionados</h2>
              </b-col>
              <b-col class="m-2">
                <v-select :options="purchaseOrderOptions" label="text" v-model="form.purchase_order"> </v-select>
              </b-col>
            </b-row>
            <b-table :items="form.selected_pallets" :fields="columns_selected_pallets">
              <template v-slot:cell(acciones)="row">
                <a href="#" @click.prevent="removeRow(row.item)"><i class="fa fa-close text-danger"></i></a>
              </template>
            </b-table>
          </b-card>
          <b-button @click.prevent="onSubmit" class="float-right px-5" variant="primary"><b>Guardar</b></b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import { required } from "vuelidate/lib/validators";
Vue.use(ServerTable);
window.axios = require("axios");
export default {
  name: "ChangePalletStatus",
  components: {
    ServerTable
  },
  validations: {
    form: {
      purchase_order: { required },
      selected_pallets: { required }
    }
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      // this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });
    this.getPurchaseOrderList();
  },
  computed: {
    mapPalletsIds() {
      return this.form.selected_pallets.map((item) => item.id);
    }
  },
  watch: {
    "form.purchase_order": function (val) {
      this.url = "/storage/pallet/?no_ops&container=" + val.container;
      this.$nextTick(() => {
        this.$refs.table.refresh();
      });
    }
  },
  methods: {
    resetForm() {
      this.form.selected_pallets = [];
      this.form.purchase_order = null;
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError || this.form.selected_pallets.length == 0) {
        this.$swal.fire("Atención", "Debe seleccionar almenos 1 pallet y seleccionar una clasificación", "warning");
        return;
      }
      this.onSubmitSuccess();
    },
    async onSubmitSuccess() {
      const self = this;
      self.loading = true;
      const payload = {
        pallet_list: self.mapPalletsIds
      };
      try {
        const res = await self.$axios.put(
          `/api/v1/purchase_order/${self.form.purchase_order.id}/bulk_update_pallets/`,
          payload
        );
        if (res.status == 200) {
          self.$swal.fire("Operación realizada con éxito", "", "success");
          self.resetForm();
        }
        self.loading = false;
      } catch (e) {
        self.loading = false;
        console.log(e);
      }
    },
    async getPurchaseOrderList() {
      const self = this;
      self.loading = true;
      try {
        const res = await self.$axios.get("/api/v1/purchase_order/?no_page&status=vigente");
        self.loading = false;
        res.data.forEach((item) => {
          const obj = {
            id: item.id,
            text: `${item.id} - ${item.plan__week}: ${item.plan__subplan}`,
            container: item.container
          };
          self.purchaseOrderOptions.push(obj);
        });
      } catch (e) {
        console.log(e);
        self.loading = false;
      }
    },
    removeRow(e) {
      const item = {
        id: e.id,
        number: e.number
      };
      this.form.selected_pallets = this.form.selected_pallets.filter((x) => x.id !== item.id);
    },
    selectRow(e) {
      const item = {
        id: e.row.id,
        number: e.row.number
      };
      const repeated = this.form.selected_pallets.find((x) => x.id === item.id);
      if (!repeated) {
        this.form.selected_pallets.push(item);
      } else {
        this.$toast.error("Este pallet ya fue seleccionado", "");
      }
    }
  },
  data() {
    return {
      loading: false,
      url: null,
      form: {
        selected_pallets: [],
        classification: null
      },
      purchaseOrderOptions: [{ id: null, text: "Seleccione OP" }],
      columns: [
        "number",
        "position",
        "_origins",
        "_varieties",
        "_container",
        "is_complete",
        "approve",
        "_total_exportable_kilograms",
        "_total_quantity"
      ],
      columns_selected_pallets: [
        { key: "number", label: "Numero" },
        { key: "acciones", label: "" }
      ],
      options: {
        debounce: 800,
        skin: "table table-sm table-hover border-0",
        sendInitialRequest: false,
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            items.push(item);
          }
          return {
            data: items,
            count: resp.data.count
          };
        },
        columnsClasses: {
          is_complete: "text-center",
          approve: "text-center",
          _total_net_kilograms: "text-right",
          _total_exportable_kilograms: "text-right",
          _total_quantity: "text-right"
        },
        texts: {
          noResults: "No se encontraron registros.",
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:",
          loading: "...",
          defaultOption: "Selecione {column}"
        },
        perPage: 15,
        perPageValues: [15, 25, 50],
        filterByColumn: true,
        filterable: ["number", "position", "_origins", "_varieties", "is_complete", "approve"],
        listColumns: {
          is_complete: [
            { text: "Si", id: true },
            { text: "No", id: false }
          ],
          approve: [
            { text: "Si", id: true },
            { text: "No", id: false }
          ]
        },
        headings: {
          number: "Número",
          position: "Posición",
          _origins: "Huerto",
          _varieties: "Variedad",
          _container: "Formato",
          _total_exportable_kilograms: "Kilos",
          _total_quantity: "Cajas",
          is_complete: "Completo",
          approve: "Aprobado"
        },
        sortable: [],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      }
    };
  }
};
</script>

<style>
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  >>> .VueTables__row. {
    cursor: pointer !important;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
